import React from "react";
import styled from "styled-components";

const SIZE = 250;

const Circle = styled.div`
  position: relative;
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 5px solid black;
    margin: 0px auto;
    overflow: hidden;
`;

const Sector = styled.div`
  position: absolute;
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: ${SIZE}px;
  background: linear-gradient(-45deg, ${props => props.color} 30%, #ccc 90% );
  position: absolute;
  clip: rect(0px, ${SIZE}px, ${SIZE/2}px, ${SIZE/2}px);
  transform: rotate(${props => props.degree}deg);
`;

const Text = styled.div`
font-size: 18px;
    position: absolute;
    right: 25%;
    top: 25%;
    transform: translateX(50%) translateY(-50%) rotate(45deg);
`

const TimeInd = styled.div`
    position: absolute;
    width: ${SIZE}px;
    height: ${SIZE}px;
    color: #000;
    font-size: 13px;
    font-weight: 500;
    transform: rotate(${props => props.degree}deg);
`

const FourQuadrantCircle = ({ children }) => (
  <Circle>
    <Sector degree={0} color="#444">
        <Text>◯</Text>
    </Sector>
    <Sector degree={90} color="skyblue">
        <Text>●</Text>
    </Sector>
    <Sector degree={180} color="orange">
        <Text>● ●</Text>
    </Sector>
    <Sector degree={270} color="#A155b9">
        <Text>● ● ●</Text>
    </Sector>
    {(new Array(24)).fill().map((_, i) => <TimeInd key={i}
        degree={i * 15 + 15}
    >{i+1}</TimeInd>)}
    {children}
  </Circle>
);

export default FourQuadrantCircle;